import { createContext } from 'react';

import { ActionsMenuContextType } from './types';

export const ActionsMenuContext = createContext<ActionsMenuContextType>({ closeMenu: () => {} });
